class timezone {
  /**
   *
   * @returns number
   */
  getLocalTimezone = () => {
    return new Date().getTimezoneOffset() * -1;
  };
  offset = parseInt(
    localStorage?.CustomTimeZoneOffset
      ? localStorage.CustomTimeZoneOffset
      : this.getLocalTimezone()
  );
  constructor() {
    if (timezone._instance) {
      return timezone._instance;
    }
    timezone._instance = this;
  }

  /**
   * Whether the user explicitly selected a timezone from the dropdown
   */
  get isUserSelected() {
    return localStorage.getItem('IsUserSelectedTimezone') === 'true';
  }

  /**
   * Called when user explicitly selects a timezone from the dropdown (Priority 1)
   */
  updateTimezone = (newOffset = this.getLocalTimezone()) => {
    this.offset = newOffset;
    localStorage.setItem('IsUserSelectedTimezone', 'true');
    this.setOffset(newOffset);
    return this.offset;
  };

  /**
   * Apply store timezone if no explicit user selection exists (Priority 2)
   */
  applyStoreTimezone = storeOffset => {
    if (storeOffset != null && this.offset !== storeOffset) {
      this.offset = storeOffset;
      // this.setOffset(storeOffset);
    }
  };

  /**
   * Reset to default: falls back to given fallback offset or local timezone
   */
  resetToDefault = fallbackOffset => {
    localStorage.removeItem('IsUserSelectedTimezone');
    if (fallbackOffset != null) {
      localStorage.setItem('CustomTimeZoneOffset', String(fallbackOffset));
    } else {
      localStorage.removeItem('CustomTimeZoneOffset');
    }
    window.location.reload(true);
  };

  setToLocal = () => {
    localStorage.removeItem('IsUserSelectedTimezone');
    localStorage.removeItem('CustomTimeZoneOffset');
    window.location.reload(true);
  };
  setOffset = newOffset => {
    localStorage.setItem('CustomTimeZoneOffset', newOffset);
    window.location.reload(true);
  };
  isEqualToLocal = () => {
    return this.getLocalTimezone() === this.offset;
  };
}

const TimezoneOffsetInstance = new timezone();

export { TimezoneOffsetInstance };
